import DebugScreen from '@/components/DebugScreen';

export default function DebugRoute() {
  return <DebugScreen />;
}
